import { render, staticRenderFns } from "./evip-list.vue?vue&type=template&id=805378b6&"
import script from "./evip-list.vue?vue&type=script&lang=js&"
export * from "./evip-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports